import { render } from "./SourceItem.vue?vue&type=template&id=6ae4c36b&scoped=true"
import script from "./SourceItem.vue?vue&type=script&lang=js"
export * from "./SourceItem.vue?vue&type=script&lang=js"

import "./SourceItem.vue?vue&type=style&index=0&id=6ae4c36b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae4c36b"]])

export default __exports__